import { useSelector } from 'react-redux';
import { getCanShowFromPriceNoResults, getIsLoading } from '@state/search-results';
import React from 'react';
import { GeographyApi, Place } from '@model/iceberg';
import { useAsync } from 'react-use';
import { NoResults } from '../NoResults';

export interface NoResultsContainerProps {
  display: string;
  path: string;
}

export const FromPricePackagesNoResults = ({ display, path }: NoResultsContainerProps) => {
  const hasNoResults: boolean = useSelector(getCanShowFromPriceNoResults);
  const isLoading: boolean = useSelector(getIsLoading);
  const api: GeographyApi = new GeographyApi();
  const response = useAsync(async () => await api.getPlaceByPath(path), []);
  if (response.loading || !response.value || !response.value.place) return null;
  const place: Place = response.value.place;

  return <NoResults hasNoResults={hasNoResults} isLoading={isLoading} isDestination name={display} place={place} />;
};
